import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScanAndGoService {
    private readonly BASE_URL: string;

    constructor(private http: HttpClient) {
        this.BASE_URL = `${environment.serverURL}/scan-and-go`;
    }

    generateNewOrder(): Observable<any> {
        const body = { origin: 'scan-and-go' };
        const url = `${this.BASE_URL}/generate-order`;
        return this.http.post<any>(url, body);
    }

    setOrderToPay(paymentIsOnline: boolean, orderId: number, paymentId?: string): Observable<any> {
        const body = {
            action: (paymentIsOnline) ? 'PO' : 'TO',
            order: orderId,
        };

        if (paymentIsOnline) {
            body['payment_src'] = paymentId;
        }

        const url = `${this.BASE_URL}/set-order-to-pay`;
        return this.http.post<any>(url, body);
    }
}
